/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StepForm } from '../../models/step-form';

export interface CasesCaseIdStepsStepIdFormGet$Params {
  caseId: string;
  stepId: string;
}

export function casesCaseIdStepsStepIdFormGet(http: HttpClient, rootUrl: string, params: CasesCaseIdStepsStepIdFormGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StepForm>> {
  const rb = new RequestBuilder(rootUrl, casesCaseIdStepsStepIdFormGet.PATH, 'get');
  if (params) {
    rb.path('caseId', params.caseId, {});
    rb.path('stepId', params.stepId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StepForm>;
    })
  );
}

casesCaseIdStepsStepIdFormGet.PATH = '/cases/{caseId}/steps/{stepId}/form';
